<template>
  <el-drawer
    title="详情"
    :visible.sync="drawer"
    :destroy-on-close="true"
    :close-on-press-escape="false"
    :before-close="handleClose"
    size="50%"
    withHeader="false"
  >
    <div class="title-box">基本信息</div>
    <el-descriptions :column="1" style="margin-left: 40px">
      <el-descriptions-item label="活动名称">{{ info.name }}</el-descriptions-item>
      <el-descriptions-item label="活动链接">
        <div class="url-box">
          <a :href="info.url" target="_blank" style="color: #409eff">{{ info.url }}</a>
        </div>

        <el-button type="primary" @click="copyUrl(info.url)" size="mini" style="margin-left: 10px"
          >复制</el-button
        >
      </el-descriptions-item>
      <el-descriptions-item label="隶属公司">{{ info.merchantName }}</el-descriptions-item>
      <el-descriptions-item label="活动时间"
        >{{ info.startTime }} 至 {{ info.endTime }}</el-descriptions-item
      >
    </el-descriptions>
    <div class="title-box">乘客端展示</div>
    <el-descriptions :column="1" style="margin-left: 40px">
      <el-descriptions-item label="活动头图">
        <el-image
          :src="info.headImgUrl"
          style="width: 120px; margin-left: 30px"
          :preview-src-list="[info.headImgUrl]"
        />
      </el-descriptions-item>
      <el-descriptions-item label="活动背景色">{{ info.backcolor }}</el-descriptions-item>
      <el-descriptions-item label="活动规则">
        <div v-html="info.rule"></div>
      </el-descriptions-item>
    </el-descriptions>
    <div class="title-box">活动奖励</div>
    <el-table
      :data="info.couponInfoList"
      border
      size="mini"
      max-height="280px"
      style="margin: 0 10px"
    >
      <el-table-column label="序号" type="index" width="50" align="center" />
      <el-table-column label="优惠券名称" align="center" prop="couponName" />
      <el-table-column label="所属礼包" align="center" prop="giftName" />
      <el-table-column label="金额/个" align="center" prop="discountsMoney" />
      <el-table-column label="每次领取数量" align="center" prop="num" />
    </el-table>
    <div class="descriptions-text">每人限领 {{ info.everyPersonTime }} 次</div>
    <div style="display: flex; align-items: center; margin-bottom: 20px">
      <div class="descriptions-text">可参与人次：</div>
      <el-descriptions
        :column="2"
        border
        direction="vertical"
        style="width: 200px"
        size="mini"
        :contentStyle="rowCenter"
        :labelStyle="rowCenter"
      >
        <el-descriptions-item label="总量">{{ info.personTime }}</el-descriptions-item>
        <el-descriptions-item label="剩余">{{ info.surplus }}</el-descriptions-item>
      </el-descriptions>
    </div>

    <div class="title-box">其他</div>
    <div class="bottom-box">
      <el-descriptions :column="1" style="margin-left: 40px">
        <el-descriptions-item label="创建人">{{ info.createUser }}</el-descriptions-item>
        <el-descriptions-item label="审核人">{{ info.auditUser }}</el-descriptions-item>
        <el-descriptions-item label="活动状态">{{ info.statusTr }}</el-descriptions-item>
        <el-descriptions-item v-if="info.refuseMsg" label="不通过原因">{{
          info.refuseMsg
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="1">
        <el-descriptions-item label="创建时间">{{ info.createTime }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{ info.auditTime }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>

<script>
  import { getInfo } from '@/api/marketing/activities-api'
  import { copyText } from '@/util/util'

  export default {
    data() {
      return {
        drawer: false,
        info: {
          url: ''
        },
        rowCenter: {
          'text-align': 'center'
        }
      }
    },
    methods: {
      init(id) {
        this.advertisingId = id
        this.getInfoFetch(id)
      },
      getInfoFetch(id) {
        this.$loading()
        getInfo(id)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              this.info = data
              this.info.url = `https://www.ayundi.cn/databoard/#/activity-coupon?receiveCouponId=${data.id}`
              this.drawer = true
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      handleClose() {
        this.title = ''
        this.info = {}
        this.drawer = false
      },
      // 复制链接
      async copyUrl(url) {
        await copyText(url)
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title-box {
    margin: 0 0 20px 20px;
    font-size: 18px;
    font-weight: 500;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }

  .bottom-box {
    display: flex;
  }

  .descriptions-text {
    text-align: left;
    font-weight: 400;
    line-height: 1.5;
    font-size: 14px;
    margin-left: 40px;
    margin-bottom: 10px;
  }
  .url-box {
    color: #409eff;
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
